// extracted by mini-css-extract-plugin
module.exports = {"loadSectionButton":"Sections_loadSectionButton__23cSd"};